import styles from './styles.module.scss';

export const Title = ({
  title,
  dataTest,
}: { title: string, dataTest: string }) => (
  <h2 className={ styles.title } data-test={ dataTest }>{ title }</h2>
);
